// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2g9wLttlQb-QtM {\n  height: 32px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 70%;\n  margin: 0 auto;\n}\n._2g9wLttlQb-QtM::before {\n  content: '';\n  display: block;\n  width: 100%;\n  border-top: 2px solid #C1C7D0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCardFront": "_2g9wLttlQb-QtM"
};
export default ___CSS_LOADER_EXPORT___;
